import styled from "styled-components";

export const Container = styled.div`
    position: relative;
    z-index: 1000;
`;
